<button
  mat-icon-button
  color="primary"
  [matMenuTriggerFor]="menu"
  aria-label="Open actions menu"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  @if (canEdit()) {
    <button
      mat-menu-item
      aria-label="Edit item"
      (click)="onEdit()"
    >
      <mat-icon>edit</mat-icon>
      Edit
    </button>
  }
  @if (canDelete()) {
    <button
      mat-menu-item
      aria-label="Delete item"
      (click)="onDelete()"
    >
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  }
</mat-menu>
